// AiFormattedText.jsx — render **bold** markers in Ai copy

import React, { useMemo } from 'react';

// Utilities
import splitBoldSegments from 'spaces/utils/formatAiFeedText';

const AiFormattedText = React.memo(({ text = '', keyPrefix = 'text' }) => {

    // ----- MEMOS ----- //

    const segments = useMemo(() => splitBoldSegments(text), [text]);

    // ----- RENDER ----- //

    return segments.map((segment, index) => (
    segment.bold ? (
      <strong key={`${keyPrefix}-${index}-${segment.text}`}>{segment.text}</strong>
    ) : (
      <React.Fragment key={`${keyPrefix}-${index}-${segment.text}`}>{segment.text}</React.Fragment>
    )
  ));
});

// Dev Tools
AiFormattedText.displayName = 'AiFormattedText';

export default AiFormattedText;
